function ValidateQuota(questionSetQuotas) {
	var validationErrors = [];
	questionSetQuotas.forEach((questionSet) => {
		questionSet.quotas.forEach((quota) => {
			if (!quota.limit || quota.limit === '') {                    
				addErrorMessage(validationErrors, 'limit', 'Quota limit is empty');
			}	
		});		
	});
	return validationErrors;
}

function addErrorMessage(validationErrors, field, message) {      
	validationErrors.push({ field: field, errorMessage: message});      
}

export default ValidateQuota;